/* @jsx h */
import { defineComponent, h, onMounted, ref, type PropType } from "vue";
import type { GridColumnDef, CommitDir } from "./types";

export const BooleanEditor = defineComponent({
  name: "BooleanEditor",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: [Boolean, Number, null] as any, default: null },
    onCommit: {
      type: Function as PropType<(value: any, dir: CommitDir) => void>,
      required: true,
    },
  },
  setup(props) {
    const checked = ref(Boolean(props.value));

    onMounted(() => {
      // Toggle immediately on Enter/Space — commit right away
    });

    const toggle = () => {
      const next = !checked.value;
      checked.value = next;
      props.onCommit(next ? 1 : 0, null);
    };

    return () => (
      <label
        class="flex h-full w-full items-center justify-center cursor-pointer"
        onClick={toggle}
      >
        <input
          type="checkbox"
          class="toggle toggle-primary toggle-sm"
          checked={checked.value}
          onChange={() => {}} // controlled via onClick on label
        />
      </label>
    );
  },
});
